<template>
  <div class="quick-message">
    <div class="container">
       <div class="message message-movement text-600"
          :class="{'success': isSuccess, 'failure': !isSuccess, 'active': hasMessage}">
        <b-row no-gutters>
          <b-col cols="auto"
                class="icon">
            <inline-svg v-if="isSuccess"
                        src="CircleCheckFilledIcon"
                        class="icon--green">
            </inline-svg>
            <inline-svg v-else
                        src="AlertFilledIcon"
                        class="icon--red">
            </inline-svg>
          </b-col>
          <b-col>
            {{ quickMessageText }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
// Libraries
import { mapState } from 'vuex'

// Components
import InlineSvg from './InlineSvg.vue'

// Enums
import { NotificationTypeEnum } from '../../../constants.js'

// Services
import { EventBus } from '../../../services/eventBusService'

// Utilities
import isEmpty from '../../../utility/isEmpty'

export default {
  name: 'quick-message',

  components: {
    InlineSvg
  },

  data () {
    return {
      dismissTimerId: null
    }
  },

  mounted () {
    EventBus.$on('ClearMessage', this.clearMessage)
  },

  beforeDestroy () {
    EventBus.$off('ClearMessage', this.clearMessage)
  },

  watch: {
    quickMessageText () {
      // When the text is set, wait 5 seconds and then clear the message, thus hiding the component
      this.dismissTimerId = setTimeout(() => {
        this.$store.commit('display/setQuickMessage', { message: '', isError: !this.isSuccess })
      }, 5000)
    }
  },

  computed: {
    isSuccess () {
      return this.quickMessageType === NotificationTypeEnum.success
    },

    hasMessage () {
      return !isEmpty(this.quickMessageText)
    },

    ...mapState('display', ['quickMessageText', 'quickMessageType'])
  },

  methods: {
    clearMessage () {
      if (!isEmpty(this.dismissTimerId)) {
        clearTimeout(this.dismissTimerId) // stop any running timer to avoid a potential race condition when navigating
        this.$store.commit('display/setQuickMessage', { message: '', isError: !this.isSuccess }) // clear message to avoid carrying messages from one page to another
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use '../../../assets/styles/colors';

.quick-message {
  position: absolute;
  z-index: 100; // to show over the SetupHeader and page title header
  width: 100%;
  height: 0;

  .container {
    height: 0;
    margin-bottom: 0;
  }
}

.message {
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.25rem 0 colors.$black-25op;
}

.message-movement {
  z-index: 100;
  visibility: hidden;
  opacity: 0;
  transform: translateY(72px) !important;
  transition: all .5s ease-out;
}

.message-movement.active {
  visibility: visible;
  opacity: 1;
  transform: translateY(72px) !important;
}

.success {
  color: colors.$green-1;
  background-color: colors.$green-7;
}

.failure {
  color: colors.$red-5;
  background-color: colors.$red-4;
}

.icon {
  display: flex;
  align-items: center;
  margin-right: .75rem;
}

.icon--green {
  max-width: 1.25rem;
  max-height: 1.25rem;

  ::v-deep .svg-fill {
    fill: #3B8112 !important;
  }
}

.icon--red {
  max-width: 1.25rem;
  max-height: 1.25rem;

  ::v-deep .svg-fill {
    fill: colors.$red-5 !important;
  }
}
</style>
